/* QF LCP Fix v2.9.2 — eager load first 4 above-fold product images */
document.addEventListener('DOMContentLoaded', function() {
  var cards = document.querySelectorAll('.product-card-sli, .snize-product');
  cards.forEach(function(card, idx) {
    var img = card.querySelector('img');
    if (!img) return;
    if (idx < 4) {
      img.loading = 'eager';
      img.fetchPriority = 'high';
      img.setAttribute('fetchpriority', 'high');
      if (img.dataset.src && img.src.indexOf('cdn.shopify') === -1) {
        img.src = img.dataset.src;
        img.classList.remove('lazyload', 'lazy', 'lazy2');
      }
    } else {
      if (!img.loading) img.loading = 'lazy';
    }
    if (!img.alt) img.alt = '';
  });
  document.querySelectorAll('img:not([alt])').forEach(function(img){ img.alt = ''; });
});

/* Re-run after Searchanise renders its grid */
[500, 1200, 2500].forEach(function(delay) {
  setTimeout(function() {
    var cards = document.querySelectorAll('.product-card-sli, .snize-product');
    cards.forEach(function(card, idx) {
      var img = card.querySelector('img');
      if (!img || idx >= 4) return;
      if (img.loading !== 'eager') {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
        if (img.dataset.src && img.src.indexOf('cdn.shopify') === -1) {
          img.src = img.dataset.src;
          img.classList.remove('lazyload', 'lazy', 'lazy2');
        }
      }
    });
  }, delay);
});
